import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { CartTotalsComponent } from '@spartacus/cart/base/components';
import { ActiveCartFacade, Cart, OrderEntry } from '@spartacus/cart/base/root';
import { RoutingService, WindowRef } from '@spartacus/core';
import { LAUNCH_CALLER, LaunchDialogService } from '@spartacus/storefront';
import { timingSafeEqual } from 'crypto';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CustomValidateCartService } from 'src/app/services/cart/validate-cart.service';
import { CustomCheckoutService } from "src/app/spartacus/custom/core/src/checkout/facade/custom-checkout.service";

@Component({
  selector: 'cx-cart-totals',
  templateUrl: './custom-cart-totals.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomCartTotalsComponent extends CartTotalsComponent implements OnInit, OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  cart$: Observable<Cart>;
  entries$: Observable<OrderEntry[]>;
  checkoutUrl = false;
  length = true;
  buttonSpinner = false;

  constructor(
    protected activeCartService: ActiveCartFacade,
    protected customValidateCartService: CustomValidateCartService,
    protected launchDialogService: LaunchDialogService,
    protected vcr: ViewContainerRef,
    protected store: Store,
    protected routingService: RoutingService,
    protected winRef: WindowRef,
    protected customCheckoutService: CustomCheckoutService,
  ) {
    super(activeCartService);
    this.subscriptions.add(
      combineLatest([
        this.customValidateCartService.getRealTimeStockLoading(),
        this.customValidateCartService.getRealTimeStockSuccess(),
        this.customValidateCartService.getRealTimeStockError(),
      ]).subscribe(([
                      realStockLoading,
                      realStockSuccess,
                      realStockError,
                    ]) => {
        if (realStockLoading) {
          this.launchDialogService.launch(
            LAUNCH_CALLER.VALIDATE_CART_SPINNER,
            this.vcr,
          );
        }
        if (realStockSuccess) {
          const spinner = this.winRef.document.getElementsByClassName('cx-dialog-popover-center-backdrop')[0];
          if (this.winRef.document.getElementsByClassName('cx-dialog-popover-center-backdrop').length) {
            spinner.remove();
          }
          if (this.checkoutUrl) {
            this.customCheckoutService.onCheckoutBeginEvent();
            this.routingService.go({ cxRoute: 'checkout' });
          }
        }
        if (realStockError) {
          const spinner = this.winRef.document.getElementsByClassName('cx-dialog-popover-center-backdrop')[0];
          if (this.winRef.document.getElementsByClassName('cx-dialog-popover-center-backdrop').length) {
            spinner.remove();
          }
          this.customValidateCartService.redirectToCartPage();
        }
      }),
    );
  }

  realtimeStock(): any {
    this.buttonSpinner = true;
    this.customValidateCartService.realTimeStock().subscribe({
      next: (response) => {
        this.buttonSpinner = false;
      },
    });
    this.checkoutUrl = true;
  }

  ngOnInit(): void {
    this.subscriptions.add(this.customValidateCartService.getProductsModifiedLoading().subscribe(success => {
      if (!success) {
        this.cart$ = this.activeCartService.getActive();
      }
    }));
    this.entries$ = this.activeCartService
      .getEntries()
      .pipe(filter((entries) => entries.length > 0));
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
